import { FEATURES } from '@/constants/features';
import { canAccessFeature } from '@/utils/access';
import { canvasOnScreen } from '@/services/canvasContext';

export function agentPopupProfile(user) {
  if (!user) return null;
  if (canvasOnScreen() && canAccessFeature(FEATURES.MODULE_CANVAS_AGENT)) return 'canvas';
  if (user.is_superuser && canAccessFeature(FEATURES.MODULE_AGENT)) return 'full';
  return null;
}
